var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCheckWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3232 0.294296L5.04373 7.57383L1.71553 4.24564C1.32304 3.85323 0.686796 3.85323 0.294306 4.24564C-0.0981022 4.63813 -0.0981022 5.27437 0.294306 5.66686L4.33312 9.70567C4.52936 9.90184 4.78655 10 5.04373 10C5.30091 10 5.5581 9.90184 5.75434 9.70567L13.7444 1.7156C14.1368 1.32311 14.1368 0.686866 13.7444 0.294377C13.3519 -0.0981122 12.7156 -0.0981122 12.3232 0.294296Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWide);
export default __webpack_public_path__ + "static/media/checkWide.92c91072a65251d6eb926194f52516ae.svg";
export { ForwardRef as ReactComponent };